<template>
  <div>
    <h2 style="margin-bottom: 16px">通道账号管理</h2>
    <!-- 添加新账号区域 -->
    <a-card style="margin-bottom: 24px; max-width: 500px">
      <a-button type="primary" @click="openAddDialog">创建账号</a-button>
    </a-card>

    <!-- 账号列表表格 -->
    <x-table
      :columns="columns"
      :data-source="tableData"
      :loading="loading"
      rowKey="id"
      bordered
      :pagination="false"
    >
      <template #type="{ record }">
        <span>{{ record.type === 0 ? "内部" : "外部" }}</span>
      </template>
      <template #count="{ record }">
        <a @click="viewChannels(record)">{{ record.count }}</a>
      </template>
    </x-table>
    <a-pagination
      :current="pageNo"
      :page-size="pageSize"
      :total="total"
      @change="onPageChange"
      style="margin-top: 16px; text-align: right"
    />

    <!-- 添加账号弹窗 -->
    <x-dialog
      :visible="addDialogVisible"
      title="创建账号"
      xWidth="400px"
      @cancel="closeAddDialog"
      @confirm="handleAddAccount"
      :confirmLoading="addLoading"
    >
      <a-form :model="addForm" :rules="addFormRules" ref="addFormRef">
        <a-form-item label="账号名称" name="accountName" required>
          <a-input
            v-model:value="addForm.accountName"
            placeholder="请输入账号名称"
          />
        </a-form-item>
        <a-form-item label="账号类型" name="type" required>
          <a-select v-model:value="addForm.type" style="width: 120px">
            <a-select-option :value="0">内部</a-select-option>
            <a-select-option :value="1">外部</a-select-option>
          </a-select>
        </a-form-item>
        <!-- <a-form-item label="自动通道" name="isSuffix" required>
          <a-radio-group v-model:value="addForm.isSuffix">
            <a-radio :value="1">带</a-radio>
            <a-radio :value="0">不带</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="通道地址前缀" name="url" required>
          <a-input v-model:value="addForm.url" placeholder="请输入通道地址前缀" />
        </a-form-item> -->
      </a-form>
    </x-dialog>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from "vue";
import { message } from "ant-design-vue";
import { channelAccountList, channelAccountCreate } from "@/api/api";
import XTable from "@/components/XATable.vue";
import XDialog from "@/components/XDialog.vue";
import type { FormInstance } from "ant-design-vue";
const tableData = ref([]);
const loading = ref(false);
const pageNo = ref(1);
const pageSize = ref(10);
const total = ref(0);
const emit = defineEmits(["switchTab"]);
const columns = [
  { title: "ID", dataIndex: "id", key: "id", width: 80 },
  { title: "账号名称", dataIndex: "accountName", key: "accountName" },
  { title: "类型", dataIndex: "type", key: "type", width: 100 },
  {
    title: "通道数量",
    dataIndex: "count",
    key: "count",
    scopedSlots: { customRender: "count" },
    width: 120,
  },
  {
    title: "创建时间",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 180,
    isAllTime: true,
  },
];

const fetchTableData = async () => {
  loading.value = true;
  try {
    const res = await channelAccountList({
      pageNo: pageNo.value,
      pageSize: pageSize.value,
    });
    tableData.value = res.data.records || [];
    total.value = res.data.total || 0;
  } catch (e) {
    message.error("获取账号列表失败");
  } finally {
    loading.value = false;
  }
};

const addDialogVisible = ref(false);
const addForm = ref({
  accountName: "",
  type: 0,
  //   isSuffix: 1,
  //   url: "",
});
const addFormRef = ref<FormInstance>();
const addLoading = ref(false);
const addFormRules = {
  accountName: [{ required: true, message: "请输入账号名称" }],
  type: [{ required: true, message: "请选择账号类型" }],
  //   isSuffix: [{ required: true, message: "请选择自动通道" }],
  //   url: [{ required: true, message: "请输入通道地址前缀" }],
};
const openAddDialog = () => {
  addDialogVisible.value = true;
  addForm.value = { accountName: "", type: 0 };
  addFormRef.value?.resetFields();
};
const closeAddDialog = () => {
  addDialogVisible.value = false;
};
const handleAddAccount = async () => {
  if (!addFormRef.value) return;
  try {
    await addFormRef.value.validate();
    addLoading.value = true;
    const res = await channelAccountCreate({ ...addForm.value });
    if (res.code === "200") {
      message.success("创建成功");
      closeAddDialog();
      fetchTableData();
    } else {
      message.error(res.msg);
    }
  } catch (e) {
    // 校验失败自动提示
  } finally {
    addLoading.value = false;
  }
};

const viewChannels = (record: any) => {
  // 查看通道逻辑
  emit("switchTab", record.id);
};

const onPageChange = (page: number) => {
  pageNo.value = page;
  fetchTableData();
};
const props = defineProps({
  isRefresh: {
    type: Boolean,
    default: false,
  },
});

onMounted(() => {
  fetchTableData();
});

watch(
  () => props.isRefresh,
  (cur, old) => {
    fetchTableData();
  }
);
</script>

<style scoped>
.ant-card {
  background: #fff;
}
</style>
